import _ from 'lodash';

export const OPEN_WINDOW  = 'OPEN_WINDOW';
export const CLOSE_WINDOW = 'CLOSE_WINDOW';
export const SET_MAP      = 'SET_MAP';

export const SAVE_ZOOM  = 'SAVE_ZOOM';
export const RESET_ZOOM = 'RESET_ZOOM';

export const saveZoom = (zoom) =>
{
    return (dispatch) =>
    {
        return dispatch({ type: SAVE_ZOOM, zoom: zoom });
    }
};

export const resetZoom = () =>
{
    return (dispatch) =>
    {
        return dispatch({ type: RESET_ZOOM });
    }
};

export const openWindow = (window) => {
    return (dispatch, getState) => {
        let places = getState().places.items;
        let place  = _.find(places, { id: window });
        dispatch({
            type  : OPEN_WINDOW,
            window: window,
            place : place
        });
    }
};

export const closeWindow = () => {
    return (dispatch) => {
        dispatch({ type: CLOSE_WINDOW });
    }
};

export const setMapObject = (mapObject) => {
    return (dispatch, getState) =>
    {
        if (false === getState().map.mapObject)
        {
            dispatch({
                type: SET_MAP,
                mapObject: mapObject
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/actions/MapAction.js